export const Getters = {
  // implement getters here...
  getAgentBulkMenuVisible: state => state.agentBulkMenuVisible,
  getAgentActionMenu: state => agentName => state.actionMenu[agentName],
  buildPriorities: () => ['HighBuildPriority', 'AboveNormalBuildPriority', 'NormalBuildPriority', 'BelowNormalBuildPriority', 'LowBuildPriority'],

  agentsLayout: state => state.agentsLayout,
  getAgentsLocked: state => ({
    ...state.agentsLocked,
    ...state.agentsUpdating,
  }),
  agentsList: state => state.agentsList,

  getSingleAgent: (state, getters) => name => {
    const index = getters.agentsList.map(agent => agent.Name).indexOf(name);
    if (index !== -1) return getters.agentsList[index];
    return null;
  },
  tablePagination(state) {
    return state.tablePagination;
  },
  getLogLevels: state => state.logLevels,
  agentsStatistics: (state, getters, allState, allGetters) => {
    const { 'settings/licenseObj': license = {}, 'dashboard/getTelemetryActiveInfo': activeInfo = {} } = allGetters;
    const { Cloud, Agents, ActiveCores } = activeInfo;
    const {
      TotalFixedInitiators,
      TotalFixedCIInitiators,
      AvailableFixedInitiators,
      AvailableFixedCIInitiators,
      CooldownFixedInitiators,
      CooldownFixedCIInitiators,
      TotalFloatingInitiators,
      TotalFloatingCIInitiators,
      AvailableFloatingInitiators,
      AvailableFloatingCIInitiators,
      TotalFloatingCores,
      TotalFixedCores,
      AvailableFixedCores,
      TotalBuildAvoidance,
      AvailableBuildAvoidance,
      CooldownBuildAvoidance,
    } = license;
    return {
      agentsActivity: {
        activeCores: {
          onPrem: (ActiveCores?.Remote || 0) - (Cloud?.ActiveCores || 0),
          cloud: Cloud?.ActiveCores || 0,
          initiators: ActiveCores?.Local || 0,
        },
        onlineAgentMachine: {
          online: Agents?.OnlineAgents || 0,
          active: Agents?.ActiveAgents || 0,
          idle: (Agents?.OnlineAgents || 0) - (Agents?.ActiveAgents || 0),
          cloud: Cloud?.ActiveAgents || 0,
          onPrem: (Agents?.ActiveAgents || 0) - (Cloud?.ActiveAgents || 0),
        },
        builds: Agents?.ActiveBuilds || 0,
      },
      licenseUsage: {
        initiatorLicenses: {
          all: {
            assigned: TotalFloatingInitiators - AvailableFloatingInitiators + (TotalFixedInitiators - AvailableFixedInitiators - CooldownFixedInitiators) || 0,
            available: AvailableFloatingInitiators + AvailableFixedInitiators || 0,
            cooldown: CooldownFixedInitiators || 0,
            total: TotalFloatingInitiators + TotalFixedInitiators || 0,
          },
          floating: {
            assigned: TotalFloatingInitiators - AvailableFloatingInitiators || 0,
            available: AvailableFloatingInitiators || 0,
            total: TotalFloatingInitiators,
          },
          fixed: {
            assigned: TotalFixedInitiators - AvailableFixedInitiators - CooldownFixedInitiators || 0,
            available: AvailableFixedInitiators || 0,
            cooldown: CooldownFixedInitiators || 0,
            total: TotalFixedInitiators,
          },
        },
        ciInitiatorLicenses: {
          all: {
            assigned: TotalFloatingCIInitiators - AvailableFloatingCIInitiators + (TotalFixedCIInitiators - AvailableFixedCIInitiators - CooldownFixedCIInitiators) || 0,
            available: AvailableFloatingCIInitiators + AvailableFixedCIInitiators || 0,
            cooldown: CooldownFixedCIInitiators || 0,
            total: TotalFloatingCIInitiators + TotalFixedCIInitiators || 0,
          },
          floating: {
            assigned: TotalFloatingCIInitiators - AvailableFloatingCIInitiators || 0,
            available: AvailableFloatingCIInitiators || 0,
            total: TotalFloatingCIInitiators,
          },
          fixed: {
            assigned: TotalFixedCIInitiators - AvailableFixedCIInitiators - CooldownFixedCIInitiators || 0,
            available: AvailableFixedCIInitiators || 0,
            cooldown: CooldownFixedCIInitiators || 0,
            total: TotalFixedCIInitiators,
          },
        },
        buildCache: {
          assigned: TotalBuildAvoidance - AvailableBuildAvoidance - CooldownBuildAvoidance || 0,
          available: AvailableBuildAvoidance || 0,
          cooldown: CooldownBuildAvoidance || 0,
        },
        helperCores: {
          floating: TotalFloatingCores || 0,
          fixed: {
            assigned: TotalFixedCores - AvailableFixedCores || 0,
            available: AvailableFixedCores || 0,
          },
        },
      },
    };
  },
  extendedDiskSpaceChartDataset: state => name => {
    const agentTarget = state.agentsList.find(agent => agent.Name === name);
    const totalInGB = (agentTarget.Performance.TotalDisk / 1024 / 1024 / 1024).toFixed(1);
    const availableInGB = (agentTarget.Performance.AvailDisk / 1024 / 1024 / 1024).toFixed(1);
    return [totalInGB, availableInGB];
  },

  extendedPhysicalMemChartDataset: state => name => {
    const agentTarget = state.agentsList.find(agent => agent.Name === name);
    const totalInGB = (agentTarget.Performance.TotalMem / 1024 / 1024 / 1024).toFixed(1);
    const availableInGB = (agentTarget.Performance.AvailMem / 1024 / 1024 / 1024).toFixed(1);
    return [totalInGB, availableInGB];
  },

  getFilters(state) {
    return state.filters.windows;
  },
  getLinuxFilters(state) {
    return state.filters.linux;
  },

  getAgentFiltersObjectGQL(state) {
    return state.filtersGQL.agentGQLFilters;
  },

  getFiltersGQL(state) {
    return {
      ...state.filtersGQL.agentGQLFilters,
      paging: state.filtersGQL.paging,
      // quickFilter: state.filtersGQL.quickFilter,
      // sort: state.filtersGQL.sort,
      // searchFilter: state.filtersGQL.searchFilter
    };
  },

  getExistingCoreFilters(state) {
    return state.filters.windows.coreView.existingFilters.slice().sort((a, b) => a - b);
  },

  getEnabledCoreFilters(state) {
    return state.filters.windows.coreView.enabledFilters;
  },
  getLogLevelFilters(state) {
    return state.filters.windows.logLevel;
  },
};
